import React, { createContext, useCallback, useContext, useRef, useState } from "react";
const ALLOWEDCRMS = ['Connectwise', 'SalesForce'];
const OpportunitySyncContext = createContext();
const useOpportunitySyncContext = () => useContext(OpportunitySyncContext);

const isOpportunityAutoSyncEnabled = (crm) => {
	if (crm === 'Connectwise') {
		return window.app?.settings?.global?.ConnectWiseEnableOpportunityAutoSync;
	}
	if (crm === 'SalesForce') {
		return window.app?.settings?.global?.SalesforceEnableOpportunityAutoSync;
	}
	return false;
};

const checkIfSyncEnabled = () => {
	const currentCRM = typeof window.quosal?.settings?.getValue === 'function' &&
		quosal.settings.getValue('customerProvider') || '';
    const isAutoSyncAllowed = ALLOWEDCRMS.includes(currentCRM);
	const isHistoricalQuote = window.app?.currentQuote?.IsArchive && !window.app?.currentQuote?.IsTemplate;
    const syncSettingEnabled = isOpportunityAutoSyncEnabled(currentCRM) && isAutoSyncAllowed;
	return syncSettingEnabled && !isHistoricalQuote;
};

const OpportunitySyncProvider = ({ children }) => {
	const syncEnabled = checkIfSyncEnabled();
	const [lastUpdateTime, setLastUpdateTime] = useState(null);
	const [oppClosed, setOppClosed] = useState(false);
	const [syncing, setSyncing] = useState(false);
	const [syncFinished, setSyncFinished] = useState(false);
	const [syncError, setSyncError] = useState(null);
	const callSyncRef = useRef(false);

	const callCwOppSync = useCallback(() => {
        if (!syncEnabled || window.location.href.includes('submodules=quote.customer,crm.opportunity') || window.location.href.includes('quote.customer,quote.attachopportunity')) {
			return;
		}
		if (!app.currentQuote?.IdCRMOpportunity) {
			setSyncing(false);
			setSyncFinished(false);
			setSyncError(null);
			return;
		}
		if (syncing) {
			callSyncRef.current = true;
			return;
		} 

		setSyncing(true);
		setSyncFinished(false);
		const currentCRM = quosal.settings.getValue('customerProvider');
		const saveOpportunityAPI = currentCRM === 'SalesForce'
			? quosal.api.crm.salesforce.autoSaveOpportunity(app.currentQuote.IdQuoteMain)
			: quosal.api.crm.connectwise.autoSaveOpportunity(app.currentQuote.IdQuoteMain);
		saveOpportunityAPI.finished = function (msg) {
			setSyncFinished(true);
			setOppClosed(msg.oppClosed);
			setLastUpdateTime(new Date().toLocaleString());
			if (msg.error) {
				setSyncError(msg.error);
			} else {
				setSyncError(null);
			}
			if (callSyncRef.current) {
				callSyncRef.current = false;
				setSyncing(false);
				setTimeout(() => {
					callCwOppSync();
				});
			} else {
				setSyncing(false);
			}
		}
			
		saveOpportunityAPI.call();
	}, [syncing, syncEnabled]);

	const value = {
		syncing,
		setSyncing,
		callCwOppSync,
		syncError,
		syncFinished,
		lastUpdateTime,
        syncEnabled,
		oppClosed    
	}
	
	return <OpportunitySyncContext.Provider value={value}>{children}</OpportunitySyncContext.Provider>;
};

export { OpportunitySyncProvider, useOpportunitySyncContext, checkIfSyncEnabled };
